import React from "react";

const LoadingModal = () => {
  return (
    <div
      className="loading-modal modal-wrapper"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img src={`${process.env.REACT_APP_STYLES_PATH}loader.gif`} alt="" />
    </div>
  );
};

export default LoadingModal;
